import {
    BooleanInput,
    Create,
    Edit,
    EditButton,
    List,
    NumberField,
    required,
    SimpleForm,
    TextField,
    TextInput
} from 'react-admin';
import AdminPagination from '../AdminPagination';
import AdminSelectableDatagrid from '../AdminSelectableDatagrid';
import { ResourceListTitle } from '../AdminResourceTotalCount';
import HumanDeleteButton from '../HumanDeleteButton';
import HumanRecordTitle from '../HumanRecordTitle';
import { ContentCatalogMembershipInputs } from '../ContentCatalogMembershipInputs';

const userFilters = [
    <TextInput source="all" label="Rechercher" alwaysOn />
];

export const InterludeCategoryList = (props) => {
    const demoMode = Boolean(props.demoMode);

    return (
        <List
            title={
                <ResourceListTitle
                    resource="interludecategory"
                    label={
                        demoMode
                            ? "Dossiers d'interludes — Démo"
                            : "Dossiers d'interludes"
                    }
                    queryString={`is_demo=${demoMode}`}
                />
            }
            {...props}
            filter={{ is_demo: demoMode }}
            filters={userFilters}
            bulkActionButtons={false}
            sort={{ field: 'name', order: 'ASC' }}
            perPage={50}
            pagination={<AdminPagination />}
            exporter={false}
        >
            <AdminSelectableDatagrid>
                <TextField source="name" label="Nom" />
                <NumberField source="sounds_count" label="Sons" />
                <EditButton />
                <HumanDeleteButton
                    fields={["name"]}
                    fallback="cette catégorie"
                />
            </AdminSelectableDatagrid>
        </List>
    );
};

export const InterludeCategoryEdit = (props) => (
    <Edit
        {...props}
        mutationMode="pessimistic"
        title={<HumanRecordTitle fields={["name"]} fallback="Fiche" />}
    >
        <SimpleForm redirect={props.basePath || 'list'}>
            <TextInput source="name" label="Nom" validate={required()} />
            <BooleanInput
                source="is_demo"
                label="Démo"
                validate={required()}
                defaultValue={false}
            />
            <ContentCatalogMembershipInputs
                defaultStandard={!Boolean(props.demoMode)}
            />
</SimpleForm>
    </Edit>
);

export const InterludeCategoryCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect={props.basePath || 'list'}>
            <TextInput source="name" label="Nom" validate={required()} />
            <BooleanInput
                source="is_demo"
                label="Démo"
                validate={required()}
                defaultValue={Boolean(props.demoMode)}
            />
            <ContentCatalogMembershipInputs
                defaultStandard={!Boolean(props.demoMode)}
            />
</SimpleForm>
    </Create>
);
